
import PropTypes from 'prop-types'
import React, { Component } from 'react'
import t from 'tcomb-form'
import css from './Form.module.css'

class Form extends Component {
  render () {
    return (
      <div className={css.form}>
        <form onSubmit={this.handleSubmit.bind(this)}>
          <t.form.Form
            ref='form'
            onChange={this.handleChange.bind(this)}
            type={this.props.schema}
            options={this.props.options}
            value={this.props.values} />
          {this.props.children}
        </form>
      </div>
    )
  }

  handleChange (raw, path) {
    const key = path[0]
    const value = raw[key]
    this.props.onChange(key, value)
  }

  handleSubmit (e) {
    e.preventDefault()
    const value = this.refs.form.getValue()
    if (value) {
      this.props.onSubmit(value)
    }
  }
}

Form.defaultProps = {
  onChange: () => undefined
}

Form.propTypes = {
  schema: PropTypes.func.isRequired, // TODO: replace this with whatever type tcomb-form is..
  options: PropTypes.object,
  values: PropTypes.object,
  children: PropTypes.node,
  onSubmit: PropTypes.func.isRequired,
  onChange: PropTypes.func
}

Form.displayName = 'Form'

export default Form



// WEBPACK FOOTER //
// ./ui/Form.js